import { createFileRoute } from "@tanstack/react-router";
import { PulsePage } from "@/components/updates/update-pages";

export const Route = createFileRoute("/_app/$workspaceSlug/pulse")({
  component: PulsePage,
});
